import GeneralFields from './GeneralFields';

export default GeneralFields;
